import { __assign } from "tslib";
import React from "react";
import { UncontrolledDropdown } from "../Dropdown/Dropdown";
import { DropdownItem } from "../DropdownItem/DropdownItem";
import { DropdownToggle } from "../DropdownToggle/DropdownToggle";
import { DropdownMenu } from "../DropdownMenu/DropdownMenu";
import { NavItem } from "../NavItem/NavItem";
import { ReactRouterDropDownLink, ReactRouterNavBarLink } from "./reactRouterHelper";
export var ItemComponent = function (_a) {
  var _b = _a.item,
      childItems = _b.childItems,
      Icon = _b.icon,
      title = _b.title,
      disabled = _b.disabled,
      linkProps = _b.linkProps,
      active = _b.active,
      href = _b.href,
      NavLink = _a.NavLink;

  if (childItems) {
    return React.createElement(UncontrolledDropdown, {
      nav: true,
      inNavbar: true
    }, React.createElement(DropdownToggle, {
      nav: true,
      caret: true
    }, Icon && React.createElement(Icon, {
      size: "1em"
    }), title), React.createElement(DropdownMenu, {
      right: true
    }, childItems.map(function (child, i) {
      return child.linkProps ? React.createElement(NavLink, __assign({
        key: i,
        component: ReactRouterDropDownLink
      }, child.linkProps, {
        disabled: child.disabled
      }), child.title) : React.createElement(DropdownItem, {
        key: i,
        active: child.active,
        disabled: child.disabled,
        onClick: child.onClick,
        href: child.href
      }, child.title);
    })));
  } else {
    return linkProps ? React.createElement(NavLink, __assign({
      component: ReactRouterNavBarLink
    }, linkProps, {
      disabled: disabled,
      exact: true
    }), Icon && React.createElement(Icon, null), title) : React.createElement(NavItem, {
      active: active
    }, React.createElement(NavLink, {
      href: href,
      disabled: disabled
    }, Icon && React.createElement(Icon, null), title));
  }
};